function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M0 85.337h512v341.326H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffda44",
  d: "M0 325.331h512v32H0z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M145.786 148.41l9.209 28.341h29.803l-24.11 17.518 9.208 28.343-24.11-17.516-24.11 17.516 9.21-28.343-24.11-17.518h29.801zm-51.178-29.682l5.526 17.005h17.881l-14.465 10.511 5.525 17.006-14.467-10.51-14.466 10.51 5.526-17.006-14.466-10.511h17.882z",
  fill: "#f0f0f0"
});

const SvgCuracao = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCuracao, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/curacao.678ba0d0.svg";
export { ForwardRef as ReactComponent };